"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTableRow = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _TableRowMixin = require("../../mixins/components/TableRowMixin");
var StyledTableRow = /*#__PURE__*/_styledComponents.default.tr.withConfig({
  displayName: "StyledTableRow",
  componentId: "c11n-8-107-0__sc-65t1u6-0"
})(["", ""], _TableRowMixin.TableRowMixin);
exports.StyledTableRow = StyledTableRow;